<template>
  <activity-summary @success="handleSuccess" />
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ActivitySummary from 'vue-components/activity-summary/components/activity-summary'

const { mapMutations } = createNamespacedHelpers('activitySummary')

export default {
  components: {
    ActivitySummary
  },
  props: [
    'activity'
  ],
  computed: {
    meetingEnded () {
      return !!this.activity.actualEndTime
    }
  },
  watch: {
    activity: {
      immediate: true,
      handler (activity) {
        this.setActivity(activity)
      }
    }
  },
  methods: {
    ...mapMutations([
      'setActivity'
    ]),
    handleSuccess () {
      if (this.meetingEnded) {
        this.$router.push({path: '/meetings'})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// activity-summary.vue?499d11f7